import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";
import ButtonGroup from "../../../../ui/components/ButtonGroup";
import { MappedInput } from "../../../../ui/components/Input";
import { MappedSelect } from "../../../../ui/components/Select";
import { getAnalyte } from "./_redux/selectors";
import { groupsList, initialValues, typesList, unitsList } from "./constants";
import { addAnalyte, getAnalyteById, modifyAnalyte } from "./_api";
import { useFetch } from "../../../../hooks/fetch.hook";
import { AnalyteDetailsSchema } from "../../../../helpers/schemas";
import { sortHelper, formatDate } from "../../../../ui/helpers";
import { TextField, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiFormLabel-root": {
      color: "#71bf44",
      paddingRight: 12,
      background: "white",
    },
    "& input:disabled + fieldset": {
      borderColor: "#71bf44 !important",
      borderWidth: 2,
    },
  },
}));

export const Card = ({
  match: {
    params: { id },
  },
}) => {
  const { request } = useFetch();
  const history = useHistory();
  const classes = useStyles();

  const data = useSelector(getAnalyte(id));

  const [cardData, setCardData] = useState({});

  useEffect(() => {
    if (id && !data) {
      request(getAnalyteById, id).then((data) => data && setCardData(data));
    } else {
      setCardData(data);
    }
    // eslint-disable-next-line
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    request(id ? modifyAnalyte : addAnalyte, values, id)
      .then((data) => data && history.push("/settings/analytes"))
      .finally(() => setSubmitting(false));
  };

  const handleClose = () => history.goBack();

  if (id && !Object.keys(cardData).length) {
    return <Skeleton variant="rect" width={"100%"} height={520} />;
  }

  return (
    <div className="border border-secondary bg-white p-10">
      <Formik
        onSubmit={handleSubmit}
        initialValues={id ? cardData : initialValues}
        validationSchema={AnalyteDetailsSchema}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <>
            <h3 className="mb-10">
              <strong>{id ? cardData.name : "Add Analyte"}</strong>
            </h3>
            <div className="row justify-content-between">
              <div className="col-8">
                {id && <MappedInput label="Analyte ID" name="code" disabled />}
                <MappedInput
                  label="Analyte Name"
                  name="name"
                  data-testid="name"
                />
                <MappedInput
                  label="Analyte Limit of Reporting Value"
                  name="reporting_value"
                  data-testid="reporting_value"
                />
                <MappedSelect
                  label="Analyte Reporting Unit"
                  options={unitsList.sort(sortHelper)}
                  name="reporting_unit"
                  data-testid="reporting_unit"
                />
                <MappedSelect
                  label="Type"
                  options={typesList.sort(sortHelper)}
                  name="type"
                  data-testid="type"
                />
                <MappedSelect
                  label="Group"
                  options={groupsList.sort(sortHelper)}
                  name="group"
                  data-testid="group"
                />
                <MappedInput
                  label="Common Product Name"
                  name="common_product_name"
                  multiline
                  data-testid="common_product_name"
                  rows={6}
                />
              </div>
              <div className="col-4">
                <TextField
                  className={classes.root}
                  label="Created Date"
                  variant="outlined"
                  defaultValue={formatDate(values.created_at)}
                  disabled
                />
                <TextField
                  className={`${classes.root} mt-5`}
                  label="Last Modified"
                  variant="outlined"
                  defaultValue={formatDate(values.last_modified)}
                  disabled
                />
              </div>
            </div>
            <div className="mt-10">
              <ButtonGroup
                handleClose={handleClose}
                handleSubmit={handleSubmit}
                isSubmitting={isSubmitting}
                textTransofrm="uppercase"
                size="large"
              />
            </div>
          </>
        )}
      </Formik>
    </div>
  );
};
